import { motion } from "framer-motion";
import { Phone, Heart, MapPin, BadgeCheck } from "lucide-react";
import Sparkles from "@/components/Sparkles";

const HERO_IMG =
  "https://images.unsplash.com/photo-1649083048597-d7b4f1e8a386?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxicmlnaHQlMjBzcG90bGVzcyUyMGhvbWUlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODYzOTYzNjF8MA&ixlib=rb-4.1.0&q=85";

const Hero = () => (
  <section id="top" className="relative overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0">
      <img
        src={HERO_IMG}
        alt="Bright, spotless home interior cleaned by Glow & Shine Sisters"
        className="h-full w-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/25" />
    </div>
    <Sparkles />

    <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8 lg:py-40">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="max-w-2xl"
      >
        <p className="mb-4 flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-[#674EA7]">
          <MapPin className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" />
          Camden, NJ &amp; South Jersey
        </p>
        <h1 className="text-4xl font-light tracking-tight text-[#2C2A35] sm:text-5xl lg:text-6xl" data-testid="hero-headline">
          We Make Your Space{" "}
          <span className="font-script gold-shimmer block text-5xl font-normal sm:text-6xl lg:text-7xl">
            Glow &amp; Shine
          </span>
        </h1>
        <p className="mt-6 text-base leading-relaxed text-[#6B6776] sm:text-lg" data-testid="hero-subheadline">
          Professional cleaning for homes, apartments, offices, and schools.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <a
            href="#quote"
            data-testid="hero-quote-button"
            className="rounded-full bg-[#8E7CC3] px-8 py-4 text-center text-sm font-bold uppercase tracking-wider text-white shadow-[0_8px_30px_rgb(142,124,195,0.4)] transition-transform hover:scale-[1.02]"
          >
            Get a Free Quote
          </a>
          <a
            href="tel:+18563080562"
            data-testid="hero-call-button"
            className="flex items-center justify-center gap-2 rounded-full border-2 border-[#D4AF37]/60 bg-white/70 px-8 py-4 text-sm font-bold uppercase tracking-wider text-[#2C2A35] backdrop-blur-sm transition-transform hover:scale-[1.02]"
          >
            <Phone className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" />
            Call Us
          </a>
        </div>
        <div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-sm font-medium text-[#6B6776]">
          <span className="flex items-center gap-2">
            <Heart className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" /> Family-Owned
          </span>
          <span className="flex items-center gap-2">
            <BadgeCheck className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" /> Reliable &amp; Professional
          </span>
          <span className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" /> Fair, Honest Pricing
          </span>
        </div>
      </motion.div>
    </div>
  </section>
);

export default Hero;
